module.exports = __webpack_public_path__ + "img/index01.afa6a418.webp";